import React, { useState, useEffect } from 'react';
import {
  createLink, extractDatacenterId, extractServerId, _t,
} from 'utils';
import { ACTIONS_TYPES } from 'redux/local';
import Section from 'screens/shared/section';
import { ROUTE } from 'constant';
import CreateForm from './create';

export default ({
  storages = [],
  history = {},
  readonly = false,
  title = _t('Storages'),
  isShowAttachButton = false,
}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(storages);
  }, [storages]);

  const clickHandler = (storage) => {
    const dcId = extractDatacenterId(storage?.href);
    const serverId = extractServerId(window.location.pathname, true);
    const params = { dcId, id: storage?.id };

    if (isShowAttachButton) history.push(createLink(ROUTE.DASHBOARD.STORAGE_IN_SERVER, { ...params, serverId, type: 'volume' }));
    else history.push(createLink(ROUTE.DASHBOARD.STORAGE, params));
  };

  return (
    <Section
      sectionTitle={title}
      itemIcon="hdd"
      setItemTitle={(e) => e?.properties?.name}
      setItemDetails={(e) => (
        <div>
          <span>{`${e?.properties?.size} GB`}</span>
          {!!e?.isBootable && <span className="m-l-15 color-success">Boot</span>}
        </div>
      )}
      itemOnClick={clickHandler}
      setItemIconText={(e) => e?.properties?.type}
      className="-m-t-24"
      items={items}
      createForm={!readonly && <CreateForm isShowAttachButton={isShowAttachButton} />}
      createActionType={[ACTIONS_TYPES.STORAGE.CREATE, ACTIONS_TYPES.SERVER.ATTACH_VOLUME]}
    />
  );
};
